// removed by extract-text-webpack-plugin
module.exports = {"blogPost":"styles-module__blogPost___nJFn-","postMeta":"styles-module__postMeta___1rbHC","body":"styles-module__body___2N7hn"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/BlogPost/styles.module.css
// module id = 55
// module chunks = 0